import { Schemas } from '~/api/gen'
import { CoordinateBalloon } from './CoordinateBalloon'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
  coordinateItems: Schemas.coordinate_item_resource[]
  isBalloonVisible: boolean
  mainImageWidth: number
}

export const CoordinateBalloonList: React.FC<Props> = ({
  coordinate,
  coordinateItems,
  isBalloonVisible,
  mainImageWidth,
}) => {
  return (
    <ul>
      {coordinateItems.map((item, i) => {
        return (
          <CoordinateBalloon
            key={i}
            coordinateItem={item}
            coordinateId={coordinate.id}
            isBalloonVisible={isBalloonVisible}
            mainImageWidth={mainImageWidth}
          />
        )
      })}
    </ul>
  )
}
